module.exports = __webpack_public_path__ + "static/pig-80352a43b4af4174e873f71dd79753e6.png";